import { getUserProfile } from "./sso-helper.js";

const TOKEN_STORAGE_KEY = 'dexterity.accessToken';

let accessToken = null;
let fetchingToken = null;

function loadTokenFromStorage() {
  try {
    const storedToken = localStorage.getItem(TOKEN_STORAGE_KEY);
    if (storedToken) {
      console.log('[AccessToken] Loaded token from localStorage');
      return storedToken;
    }
  } catch (error) {
    console.error('[AccessToken] Failed to load from localStorage:', error);
  }
  return null;
}

function saveTokenToStorage(token) {
  try {
    localStorage.setItem(TOKEN_STORAGE_KEY, token);
    console.log('[AccessToken] Saved token to localStorage');
  } catch (error) {
    console.error('[AccessToken] Failed to save to localStorage:', error);
  }
}

function clearTokenFromStorage() {
  try {
    localStorage.removeItem(TOKEN_STORAGE_KEY);
    console.log('[AccessToken] Cleared token from localStorage');
  } catch (error) {
    console.error('[AccessToken] Failed to clear from localStorage:', error);
  }
}

function isAccessTokenExpired(token) {
  if (!token) return true;

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const expirationTime = payload.exp * 1000;
    const expirationDate = new Date(expirationTime);
    const currentDate = new Date();
    const isExpired = expirationDate <= currentDate;

    if (isExpired) {
      console.log('[AccessToken] Token expired at:', expirationDate);
    }

    return isExpired;
  } catch (error) {
    console.error('[AccessToken] Failed to parse token:', error);
    return true;
  }
}

export function getToken() {
  if (!accessToken) {
    accessToken = loadTokenFromStorage();
  }

  const isExpired = accessToken === null || isAccessTokenExpired(accessToken);

  if (isExpired && !fetchingToken) {
    console.log('[AccessToken] Token expired or missing, fetching new token');

    if (accessToken) {
      clearTokenFromStorage();
      accessToken = null;
    }

    fetchingToken = new Promise((resolve) => {
      getUserProfile((result) => {
        accessToken = result;

        if (accessToken) {
          saveTokenToStorage(accessToken);
        }

        fetchingToken = null;
        resolve(accessToken);
      });
    });
  } else if (accessToken) {
    console.log('[AccessToken] Using cached token');
  }

  return fetchingToken || Promise.resolve(accessToken);
}

export function clearToken() {
  accessToken = null;
  clearTokenFromStorage();
}
